// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"62":"8d7b23cc","826":"7c9d3867","843":"e9fd8926","876":"4068a97b"}[chunkId] + ".chunk.js";
};